<template>
  <div class="c-card pa-2" style="white-space: pre;">{{ item.str }}</div>
</template>

<script>
export default {
  props: ['item']
}
</script>

